module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="xFormMetricItemWrapper '+
((__t=( extraClass ))==null?'':__t)+
'">\n  <label class="xFormMetricItemLabel"\n    >'+
((__t=( label ))==null?'':__t)+
' ';
 if(typeof(imageAssetRef)!=='undefined' && displayEmbed){ 
__p+='\n    <div class="xIcon">\n      <img\n        class="xFormMetricEmbedImage"\n        src="'+
((__t=( NGX.Util.assetPathFromRef(imageAssetRef) ))==null?'':_.escape(__t))+
'"\n        alt="'+
((__t=( imageAssetRefAltText ))==null?'':__t)+
'"\n      />\n    </div>\n    ';
 }
__p+=' ';
 if(typeof(embedCode)!=='undefined' && displayEmbed){ 
__p+='\n    <div class="xEmbed xFormMetricEmbedCode">'+
((__t=( embedCode ))==null?'':__t)+
'</div>\n    ';
 } 
__p+='\n  </label>\n  <div class="xFormMetricItemGraphWrapper">\n    '+
((__t=( itemGraph ))==null?'':__t)+
'\n  </div>\n</div>\n';
}
return __p;
};
